/** Keep local web-to-app navigation on the same development machine. */
export function isLocalAppPreview(origin = window.location.origin): boolean {
  const url = new URL(origin);
  return url.port === '3889';
}

export function appUrl(path = '/', origin = window.location.origin): string {
  const current = new URL(origin);
  const base = isLocalAppPreview(origin)
    ? `${current.protocol}//${current.hostname}:2888`
    : 'https://m.beaw.club';
  return new URL(path, base).href;
}
